<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="tabChange">
      <el-tab-pane label="1vN" name="multiple">
        <tab-multiple></tab-multiple>
      </el-tab-pane>
      <el-tab-pane label="1v1" name="single">
        <tab-single></tab-single>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import tabMultiple from "./multi/multiple.vue";
import tabSingle from "./single/single.vue";
import { PageModule } from "@/store/module/page";
export default {
  name: "classList",
  components: {
    tabMultiple,
    tabSingle,
  },
  data() {
    return {
      activeName: "multiple",
    };
  },
  created() {
    if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      this.activeName = this.$route.params.tab || "multiple";
    } else {
      const cache = PageModule.pageInfo.classManage;
      if (cache.tab) {
        this.activeName = cache.tab;
      } else {
        this.activeName = "multiple";
        PageModule.SET_PAGE_INFO({
          name: "classManage",
          key: "tab",
          value: "multiple",
        });
      }
    }
    if (this.$route.query.cl_pe === "1") {
      this.activeName = "single";
    }
  },
  methods: {
    tabChange(v) {
      PageModule.SET_PAGE_INFO({
        name: "classManage",
        key: "tab",
        value: v.name,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  /deep/.el-tabs__active-bar {
    transition: none;
  }
}
</style>
